<div>
  <div class="filter-container">
    <mat-form-field>
      <mat-label>Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filter products" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
  <table class="table" mat-table [dataSource]="tableDataSource" matSort>
    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.productName }}</td>
    </ng-container>

    <ng-container matColumnDef="stripeProductId">
      <th mat-header-cell *matHeaderCellDef>Stripe Product Id</th>
      <td mat-cell *matCellDef="let element">{{ element.stripeProductId }}</td>
    </ng-container>

    <ng-container matColumnDef="billingCycle">
      <th mat-header-cell *matHeaderCellDef>Billing Cycle</th>
      <td mat-cell *matCellDef="let element">
        {{ getBillingCycleLabel(element.subprojectProductId) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          color="primary"
          (click)="openBillingCycleModal(element)"
          aria-label="Edit Billing Cycle"
          [disabled]="!element.subprojectProductId"
        >
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let row; columns: columnNames"></tr>
  </table>
</div>
